module.exports = __webpack_public_path__ + "img/图4.6583e05f.png";